import React, { useEffect } from "react";
import { useStore } from "react-redux";
import { INTERVIEW } from "../../helpers/accessModule";
import { LIST_INTERVIEWS } from "../../helpers/accessSubmodule";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import { MainCard } from "../../components";
import List from "./InterviewsList";

const Interviews = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const store = useStore();

    const { module, submodules } = store.getState().auth.access;

    useEffect(() => {
        if (!module.includes(INTERVIEW)) {
            navigate("/403");
        }
    }, []);

    return (
        <Grid container rowSpacing={4.5} columnSpacing={2.75}>
            {submodules.includes(LIST_INTERVIEWS) && (
                <Grid item xs={12} md={12} lg={12}>
                    <MainCard title={t("listedesentretiens")}>
                        <List />
                    </MainCard>
                </Grid>
            )}
        </Grid>
    );
};

export default Interviews;
